import { resolveValue } from "@intlify/core-base";
import nl from "./nl.json";
import nlFormal from "./nl-formal.json";
import be from "./be.json";
import beFormal from "./be-formal.json";
export default () => ({
	legacy: false,
	fallbackLocale: "nl",
	fallbackWarn: false,
	missingWarn: false,
	warnHtmlMessage: false,
	missing: (locale, key, _instance) => {
		if (import.meta.client) {
			try {
				const { $i18n } = useNuxtApp();
				const fallbackLocale = $i18n.fallbackLocale.value;
				const messages = $i18n.messages.value;
				const foundInFallback = messages[fallbackLocale] && resolveValue(messages[fallbackLocale], key) !== null;
				if (!foundInFallback) {
					useTelemetry({
						message: "Missing i18n key",
						metadata: {
							key,
							locale
						}
					});
				}
			} catch (error) {
				console.error(error);
			}
		}
		return key;
	},
	messages: {
		nl: { ...nl },
		"nl-formal": {
			...nl,
			...nlFormal
		},
		be: { ...be },
		"be-formal": {
			...be,
			...nlFormal,
			...beFormal
		}
	}
});
